import React, { Component } from 'react';
import _ from 'lodash';
import { connect } from 'react-redux';
import { reduxForm, formValueSelector } from 'redux-form';

import { sendMessageAction } from '../../actions/message/sendMessageAction';
import { bookingProcess } from '../../actions/booking/bookingProcess';
import Button from '../common/FormComponents/Button';
import history from '../../core/history';
import DateRange from '../common/FormComponents/DateRange/DateRange';
import { Text, Whitespace } from '../common';

class MessagingController extends Component {
  sendMessage = (messageType, content) => {
    const {
      sendMessageAction,
      thread: { id, type },
      startDate,
      endDate,
      reservation,
    } = this.props;
    console.log(
      '660.0 - sending message from inbox',
      reservation.id,
      type,
      this.props,
    );
    sendMessageAction(
      id,
      type,
      content,
      messageType,
      startDate,
      endDate,
      reservation.id,
    );
  };

  actions = () => {
    return {
      message: content => this.sendMessage('message', content),
      approve: () => this.props.startApproval(),
      decline: () => this.sendMessage('declined'),
      cancel: () => null,
      requestreschedule: () => null,
      approvereschedule: () => null,
      declinereschedule: () => null,
      requesttobook: () => null,
    };
  };

  buildButtonGroup(actions, hasPrimary) {
    const actionOptions = this.actions();
    const buttons = actions.map((a, i) => {
      return (
        <Button
          secondary
          action={hasPrimary && i === 0}
          muted={!hasPrimary || i > 0}
          onClick={actionOptions[a.type]}
          mb={i < actions.length - 1 ? 3 : 0}
        >
          {a.text}
        </Button>
      );
    });
    return <React.Fragment>{buttons}</React.Fragment>;
  }

  renderInquiry = () => {
    const {
      userType,
      bookingProcess,
      startDate,
      endDate,
      thread,
      handleSubmit,
    } = this.props;

    return userType === 'host' ? null : (
      <div>
        <Text emphasis grayDarkMedium>
          Book this item
        </Text>
        <Whitespace smaller />
        <form
          id="RequestForm"
          onSubmit={handleSubmit(() =>
            bookingProcess(thread.listId, 0, startDate, endDate),
          )}
        >
          <DateRange
            listId={thread.id}
            minimumNights={this.props.minimumNights || 0}
            maximumNights={this.props.maximumNights || 30}
            blockedDates={this.props.blockedDates || []}
            maxDaysNotice={this.props.maxDaysNotice || 180}
            formName="RequestForm"
            change={
              this.props.change ||
              ((formName, fieldName, value) => {
                console.log('AAA DATE', formName, fieldName, value);
              })
            }
            checkAvailability={this.props.checkAvailability || (() => true)}
            showClearDates={false}
          />
          <Whitespace smaller />
          <Button secondary action>
            Request to Book
          </Button>
        </form>
      </div>
    );
  };

  renderPending = () => {
    const { userType } = this.props;
    const actionArray =
      userType === 'host'
        ? [
            { type: 'approve', text: 'Approve' },
            { type: 'decline', text: 'Decline' },
          ]
        : [];

    return this.buildButtonGroup(actionArray, true);
  };
  renderApproved = () => {
    const { userType } = this.props;
    const actionArray = [];
    // userType === 'host'
    //   ? []
    // : [{ type: 'reschedulerequest', text: 'Request Reschedule' }];

    return this.buildButtonGroup(actionArray, true);
  };
  renderCompleted = () => {
    return (
      <React.Fragment>
        <Button secondary action onClick={history.push('/review')}>
          Leave a Review
        </Button>
        ;
      </React.Fragment>
    );
  };

  render() {
    const {
      renderInquiry,
      renderPending,
      renderApproved,
      renderCompleted,
      thread,
      reservation,
    } = this.props;

    const state = reservation.reservationState;

    if (state) {
      if (state === 'inquiry') {
        return renderInquiry
          ? renderInquiry(this.actions())
          : this.renderInquiry();
      } else if (state === 'approved') {
        return renderApproved
          ? renderApproved(this.actions())
          : this.renderApproved();
      } else if (state === 'pending') {
        return renderPending
          ? renderPending(this.actions())
          : this.renderPending();
      } else if (state === 'completed') {
        return renderCompleted
          ? renderCompleted(this.actions())
          : this.renderCompleted();
      }
    }

    return null;
  }
}

MessagingController = reduxForm({
  form: 'RequestForm',
  destroyOnUnmount: false,
  forceUnregisterOnUnmount: true,
})(MessagingController);

const selector = formValueSelector('RequestForm'); // <-- same as form name

export default connect(
  state => {
    return {
      startDate: selector(state, 'startDate'),
      endDate: selector(state, 'endDate'),
    };
  },
  { sendMessageAction, bookingProcess },
)(MessagingController);



// WEBPACK FOOTER //
// ./src/components_new/messaging/MessagingController.js